import { useEffect, useState } from 'react'

import { formatFullName, serializeNameDetails } from '../utils'

export const useNameManager = (applicationProfile, titleReportMetadata, updateProfile) => {
  const [ownerNamesOptions, setOwnerNamesOptions] = useState([])

  const onUpdateName = (event) => {
    const currentName = serializeNameDetails(applicationProfile?.profile)

    // Skip updating if the selected value matches the current profile's serialized full name
    if (event.target.value === currentName) {
      return
    }

    const value = JSON.parse(event.target.value)
    const payload = {
      first_name: value?.first_name,
      middle_name: value?.middle_name,
      last_name: value?.last_name,
      suffix: value?.suffix,
    }

    updateProfile({ uuid: applicationProfile.profile.uuid, ...payload })
  }

  useEffect(() => {
    const currentName = serializeNameDetails(applicationProfile?.profile)

    const initialOptions =
      titleReportMetadata?.owners_of_record_names?.map((obj) => ({
        value: serializeNameDetails(obj),
        label: `${formatFullName(obj)} (title)`,
      })) || []

    if (!initialOptions.some((obj) => obj.value === currentName)) {
      setOwnerNamesOptions([
        ...initialOptions,
        {
          value: currentName,
          label: formatFullName(applicationProfile?.profile),
        },
      ])
    } else {
      setOwnerNamesOptions(initialOptions)
    }
  }, [applicationProfile?.profile, titleReportMetadata?.owners_of_record_names])

  return { ownerNamesOptions, onUpdateName }
}
